<template>
  <div class="newlogin resetpass" data-automation="resetPass" @keydown.13="confirm">
    <!-- tab栏 -->
    <div class="newlogin-tabbox" :class="'newlogin-tabbox-' + formData.type">
      <div
        :class="['newlogin-tab', { 'newlogin-tab-active': formData.type === item.name }]"
        v-for="item in list"
        :key="item.name"
      >
        {{ item.label }}
      </div>

      <div class="newlogin-stepbox">
        <span>{{ isCheck ? 1 : 2 }}</span
        >/2
      </div>
    </div>

    <!-- 输入框 -->
    <div class="newlogin-form">
      <div v-if="isCheck" key="newlogin-form-check">
        <div class="newlogin-form-item">
          <my-input v-model="formData.phone" :placeholder="$t('HT.register.phone.placeholder')">
            <template v-slot:prepend>
              <span class="pl16">+86</span>
            </template>
          </my-input>
        </div>
        <div class="newlogin-form-item">
          <my-input v-model="formData.imgCode" :placeholder="$t('HT.login.imgCode.placeholder')">
            <template v-slot:append>
              <img-verify ref="refImgVerify" v-model="prefix" />
            </template>
          </my-input>
        </div>
        <div class="newlogin-form-item">
          <my-input v-model="formData.code" :placeholder="$t('HT.rules.login.code')">
            <template v-slot:append>
              <time-button class="pr16" ref="time" text :time="120" @click="getCode"></time-button>
            </template>
          </my-input>
        </div>
      </div>

      <div v-else key="newlogin-form-password">
        <div class="newlogin-form-item">
          <my-input
            v-model="formData.password"
            type="password"
            show-password
            :placeholder="$t('HT.register.password.placeholder')"
          ></my-input>
        </div>
        <div class="newlogin-form-item">
          <my-input
            v-model="formData.passwdCheck"
            type="password"
            show-password
            :placeholder="$t('HT.register.passwdCheck.placeholder')"
          ></my-input>
        </div>
      </div>

      <div class="newlogin-form-bottom">
        <div class="newlogin-errorbox">
          <span>{{ errorMsg }} </span>
          <router-link v-if="isShowErrorMsgRegister" to="/register">
            <ux-button type="primary" text>{{ $t('HT.login.register') }}&gt;&gt;</ux-button>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="newlogin-footer">
      <div class="newlogin-agreement"></div>

      <template v-if="isCheck">
        <div class="newlogin-btnbox">
          <ux-button size="large" type="primary" @click="handleClickCheck">{{
            $t('HT.addApi.nextStep')
          }}</ux-button>
        </div>
      </template>

      <template v-else>
        <div class="newlogin-btnbox">
          <ux-button size="large" type="primary" @click="handleClickLogin">{{
            $t('HT.resetPass.login')
          }}</ux-button>
        </div>
      </template>

      <router-link to="/login" class="goto-login">
        <span>{{ $t('HT.resetPass.remembe') }},</span>
        <ux-button type="primary" text>{{ $t('HT.resetPass.gotoLogin') }}&gt;&gt;</ux-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import timeButton from '../template/timeButton';
import myInput from './components/myInput';
import imgVerify from '@c/imgVerify/imgVerify';
import { rules } from '@l/rules.js';

export default {
  components: {
    timeButton,
    myInput,
    imgVerify
  },
  data() {
    return {
      list: [
        {
          label: this.$t('HT.resetPass.check'),
          name: 'check'
        },
        {
          label: this.$t('HT.resetPass.resetPass'),
          name: 'setpsw'
        }
      ],
      formData: {
        type: 'check', // 选中的tab
        password: '', // 密码
        passwdCheck: '', // 二次密码
        phone: '', // 手机
        code: '', // 验证码
        imgCode: '' // 图形验证码
      },
      rules: rules,
      islogin: false, // 是否在登录(防止回车的情况下发送多次),
      agreement: false, // 是否同意
      isShowErrorMsgRegister: false,
      errorMsg: '', // 错误信息
      prefix: '' // 图形验证码前缀
    };
  },

  computed: {
    // 是否校验身份
    isCheck() {
      return this.formData.type === 'check';
    }
  },

  methods: {
    /**
     * 回车
     */
    confirm() {
      if (this.isCheck) {
        this.handleClickCheck();
      } else {
        this.handleClickLogin();
      }
    },

    /**
     * 点击下一步
     */
    handleClickCheck() {
      if (this.islogin) return;
      const validatePhoneMsg = this.validatePhone();
      if (validatePhoneMsg) {
        this.errorMsg = validatePhoneMsg;
        return;
      }

      if (!this.formData.code) {
        this.errorMsg = this.$t('HT.rules.login.code');
        return;
      }
      this.errorMsg = '';
      this.isShowErrorMsgRegister = false;
      this.check();
    },

    /**
     * 点击登录
     */
    handleClickLogin() {
      if (this.islogin) return;
      const validatePasswordMsg = this.validatePassword();
      if (validatePasswordMsg) {
        this.errorMsg = validatePasswordMsg;
        return;
      }
      const validatePasswdCheckMsg = this.validatePasswdCheck();
      if (validatePasswdCheckMsg) {
        this.errorMsg = validatePasswdCheckMsg;
        return;
      }
      this.errorMsg = '';
      this.isShowErrorMsgRegister = false;
      this.resetPassword();
    },

    /**
     * 重置密码
     */
    resetPassword() {
      this.$uxLoading.show();
      this.islogin = true;
      const { code, phone, password } = this.formData;
      let postData = {
        phone,
        code,
        password
      };
      this.$api.login
        .resetPassword(postData, { hideMsg: true })
        .then((res) => {
          this.islogin = false;
          if (res.code == 10000) {
            this.$uxMessage.success(this.$t('HT.addApi.resetSuccess'));
            this.login();
          }
        })
        .catch((err) => {
          const { sub_msg, sub_code } = err.response.data;
          this.islogin = false;
          if (sub_code === 'invalid.code') {
            // 验证码被覆盖
            this.errorMsg = this.$t('HT.register.invalid');
          } else {
            this.errorMsg = sub_msg;
          }
        });
    },

    /**
     * 登录接口
     */
    login() {
      this.$uxLoading.show();
      this.islogin = true;
      const { phone, password } = this.formData;

      let postData = {
        account: phone,
        password
      };
      this.$api.login
        .login(postData, { hideMsg: true })
        .then((res) => {
          this.islogin = false;
          if (res.code == 10000) {
            this.$store.commit('saveToken', res.data.phone + new Date().toDateString()); // 保存token
            this.$store.commit('saveUserData', res.data); // 保存用户信息
            this.$router.push('/home');
          }
        })
        .catch(() => {
          this.islogin = false;
          this.$router.push('/login');
        });
    },

    /**
     * 下一步
     */
    check() {
      let postData = {
        phone: this.formData.phone,
        code: this.formData.code
      };
      this.islogin = true;
      this.$api.login
        .identify(postData, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.formData.type = 'setpsw';
          }
          this.islogin = false;
        })
        .catch((err) => {
          this.islogin = false;
          this.formData.code = '';

          const { sub_msg, sub_code } = err.response.data;
          // 用户不存在
          if (sub_code === 'not-found.account') {
            this.errorMsg = this.$t('HT.login.text1');
            this.isShowErrorMsgRegister = true;
            return;
          }
          if (sub_code === 'invalid.sms-code') {
            this.errorMsg = this.$t('HT.login.text2');
            return;
          }
          this.errorMsg = sub_msg;
        });
    },

    /**
     * 获取验证码
     */
    getCode() {
      const validatePhoneMsg = this.validatePhone();
      if (validatePhoneMsg) {
        this.errorMsg = validatePhoneMsg;
        return;
      }

      const { phone, imgCode } = this.formData;

      if (!imgCode) {
        this.errorMsg = this.$t('HT.login.imgCode.placeholder');
        return;
      }

      this.errorMsg = '';
      this.isShowErrorMsgRegister = false;
      this.$uxLoading.show();
      const params = {
        phone,
        code: imgCode,
        prefix: this.prefix
      };

      this.$api.login
        .getIdentifyCode(params, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.$refs.time.start();
          }
        })
        .catch((err) => {
          const { sub_msg } = err.response.data;
          this.errorMsg = sub_msg;
          this.$refs.refImgVerify.getKaptcha();
          this.formData.imgCode = '';
        });
    },

    /**
     * 验证手机
     */
    validatePhone() {
      const { pattern, message } = this.rules.telphone();
      const phone = this.formData.phone;
      if (!phone) {
        return this.$t('HT.rules.login.phone');
      }
      if (!pattern.test(phone)) {
        return message;
      }
      return '';
    },

    /**
     * 验证密码
     */
    validatePassword() {
      const { pattern } = this.rules.password();
      const password = this.formData.password;
      if (!password) {
        return this.$t('HT.register.password.placeholder');
      }

      const len = password.length;

      if (len < 6) {
        return this.$t('HT.rules.validatePass1');
      }

      if (len > 18) {
        return this.$t('HT.rules.validatePass2');
      }

      if (!pattern.test(password)) {
        return this.$t('HT.rules.passwordTips');
      }
      return '';
    },

    /**
     * 二次验证密码
     */
    validatePasswdCheck() {
      const { password, passwdCheck } = this.formData;
      if (!passwdCheck) {
        return this.$t('HT.rules.editPsw.passwdCheck');
      }

      if (password !== passwdCheck) {
        return this.$t('HT.rules.validatePassCheck');
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.newlogin {
  padding: 80px 48px;

  .pr16 {
    padding-right: 16px;
  }

  .pl16 {
    padding-left: 16px;
  }

  .newlogin-tabbox {
    position: relative;
    width: 100%;
    text-align: left;
    height: 72px;

    &::before {
      content: '';
      position: absolute;
      top: 28px;
      left: 88px;
      width: 24px;
      height: 4px;
      background: $color-primary;
      transition: all 0.3s;
    }

    &.newlogin-tabbox-check::before {
      left: 0;
    }

    &.newlogin-tabbox-setpsw::before {
      left: 88px;
    }

    .newlogin-tab {
      display: inline-block;
      vertical-align: top;
      width: 88px;
      height: 24px;
      font-size: 16px;
      font-weight: 400;
      color: $color-text;
      line-height: 24px;

      &.newlogin-tab-active {
        font-size: 18px;
        color: $color-title;
        font-weight: 600;
      }
    }

    .newlogin-stepbox {
      position: absolute;
      top: 12px;
      right: 0;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: $color-text-disable;

      span {
        font-weight: 500;
        color: $color-text;
      }
    }
  }

  .newlogin-form {
    position: relative;
    height: 228px;

    .newlogin-form-item {
      margin-bottom: 16px;
    }

    .newlogin-form-bottom {
      display: flex;
      justify-content: space-between;
    }

    .newlogin-errorbox {
      color: $color-error;
    }

    .btn-forgot {
      color: $color-text-secondary;
    }
  }

  .newlogin-footer {
    .newlogin-agreement {
      height: 16px;
      margin-bottom: 16px;

      ::v-deep .ux-checkbox .el-checkbox {
        color: $color-text-secondary;
      }
    }

    .newlogin-btnbox {
      margin-bottom: 8px;

      .ux-button {
        width: 100%;
      }
    }

    .goto-login {
      padding-top: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 14px;
        color: $color-text-secondary;
        line-height: 14px;
      }
    }
  }
}
</style>
